/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ComponentSizes } from '@pc/common';

@Component({
  selector: 'pc-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './icon.component.html',
  styleUrl: './icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  @Input() size: ComponentSizes | '' = '';

  @Input() toggleIcon = false;

  @Input() disabledIcon = false;

  @Input() ariaHidden = true;

  @Input() ariaLabel = '';

  @Input() altText = '';

  @Output() clickIcon = new EventEmitter<void>();

  private _icon = '';

  private _isClickable = false;

  private matIconRegistry = inject(MatIconRegistry);

  private domSanitizer = inject(DomSanitizer);

  @HostBinding('class.active')
  get active(): boolean {
    return this.toggleIcon;
  }

  @HostBinding('class.disabled')
  get disabled(): boolean {
    return this.disabledIcon;
  }

  @HostBinding('class')
  get class(): string {
    return `size--${this.size}`;
  }

  get icon(): string {
    return this._icon;
  }

  get isClickable(): boolean {
    return this._isClickable;
  }

  @Input({ required: true })
  set icon(icon: string) {
    this._icon = icon;
    this.addSvgIcon();
  }

  @Input()
  @HostBinding('class.pointer')
  set isClickable(_isClickable: boolean) {
    this._isClickable = true;
  }

  onClick(): void {
    this.clickIcon.emit();
  }

  private addSvgIcon(): void {
    const { icon } = this;

    this.matIconRegistry.addSvgIcon(icon, this.domSanitizer.bypassSecurityTrustResourceUrl(icon));
  }
}
